if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.throttle(this.onScroll.bind(this));
        this.setHeight = this.setHeight.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        document.body.classList.add('has-mobile-dock');
        this.setAttribute('loaded', '');

        this.computeRevealOffset();
        this.setHeight();
        this.bindActions();
        this.bindCartCount();

        if (window.Shopify && Shopify.designMode) {
          this.section.classList.add('active');
          this.section.addEventListener('shopify:section:select', () => this.section.classList.add('shopify-active'));
          this.section.addEventListener('shopify:section:deselect', () => this.section.classList.remove('shopify-active'));
        } else {
          this.onScroll();
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        window.addEventListener('resize', this.throttle(() => {
          this.computeRevealOffset();
          this.setHeight();
        }), { passive: true });
      }

      get section() {
        return (this._section = this._section || this.closest('.mobile-dock-section') || this);
      }

      computeRevealOffset() {
        const header = document.querySelector('.header-wrapper, .section-header, #shopify-section-sections--header');
        this.revealOffset = header ? Math.max(parseInt(header.getBoundingClientRect().height, 10) - 40, 60) : 120;
      }

      onScroll() {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        const reached = window.scrollY >= this.revealOffset;
        this.section.classList.toggle('active', reached);
      }

      setHeight() {
        const h = this.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--mobile-dock-height', h.toFixed(1) + 'px');
      }

      bindActions() {
        const menuBtn = this.querySelector('[data-dock-menu]');
        if (menuBtn) {
          menuBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const summary = document.querySelector('#Details-menu-drawer-container > summary, header-drawer > details > summary');
            if (summary) summary.click();
          });
        }

        const cartLink = this.querySelector('[data-dock-cart]');
        if (cartLink) {
          cartLink.addEventListener('click', (e) => {
            const drawer = document.querySelector('cart-drawer:not(.is-empty), cart-drawer');
            const bubble = document.querySelector('#cart-icon-bubble');
            if (drawer && bubble && typeof drawer.open === 'function') {
              e.preventDefault();
              drawer.open(bubble);
            }
          });
        }

        const searchLink = this.querySelector('[data-dock-search]');
        if (searchLink) {
          searchLink.addEventListener('click', (e) => {
            const summaries = document.querySelectorAll('details-modal.header__search summary, .header__search summary.modal__toggle');
            let toggle = null;
            for (const s of summaries) {
              const rects = s.getClientRects();
              if (s.offsetParent !== null || (rects.length && rects[0].width > 0)) {
                toggle = s;
                break;
              }
            }
            if (!toggle && summaries.length) toggle = summaries[summaries.length - 1];
            if (toggle) {
              e.preventDefault();
              e.stopPropagation();
              toggle.click();
            }
            // if no search modal exists, the link falls through to routes.search_url
          });
        }
      }

      bindCartCount() {
        const target = this.querySelector('[data-dock-cart-count]');
        const source = document.querySelector('#cart-icon-bubble');
        if (!target) return;

        const sync = () => {
          let count = 0;
          if (source) {
            const node = source.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span');
            count = node ? parseInt(node.textContent.trim(), 10) || 0 : 0;
          }
          target.textContent = count;
          target.hidden = count === 0;
        };

        sync();
        if (source) {
          new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
        }
        document.addEventListener('cart:refresh', sync);
      }

      throttle(fn, wait = 100) {
        let last = 0;
        let timer;
        return (...args) => {
          const now = Date.now();
          const remaining = wait - (now - last);
          if (remaining <= 0) {
            clearTimeout(timer);
            last = now;
            fn.apply(this, args);
          } else if (!timer) {
            timer = setTimeout(() => {
              last = Date.now();
              timer = null;
              fn.apply(this, args);
            }, remaining);
          }
        };
      }
    },
    { extends: 'nav' }
  );
}
